{
  "Accessibility Menu": "Meni dostopnosti",
  "Reset settings": "Ponastavi nastavitve",
  "Close": "Zapri",
  "Content Adjustments": "Prilagoditve vsebine",
  "Adjust Font Size": "Prilagodi velikost pisave",
  "Highlight Title": "Označi naslov",
  "Highlight Links": "Označi povezave",
  "Readable Font": "Bralna pisava",
  "Color Adjustments": "Prilagoditve barv",
  "Dark Contrast": "Temni kontrast",
  "Light Contrast": "Svetli kontrast",
  "High Contrast": "Visoki kontrast",
  "High Saturation": "Visoka nasičenost",
  "Low Saturation": "Nizka nasičenost",
  "Monochrome": "Monokromno",
  "Tools": "Orodja",
  "Reading Guide": "Bralni vodnik",
  "Stop Animations": "Ustavi animacije",
  "Big Cursor": "Velik kazalec",
  "Increase Font Size": "Povečaj velikost pisave",
  "Decrease Font Size": "Zmanjšaj velikost pisave",
  "Letter Spacing": "Razmik med črkami",
  "Line Height": "Višina vrstice",
  "Font Weight": "Debelina pisave",
  "Dyslexia Font": "Pisava za disleksijo",
  "Language": "Jezik",
  "Open Accessibility Menu": "Odpri meni dostopnosti",
  "Accessibility Profiles": "Dostopnost profili",
  "Seizure Safe Profile": "Profil za zaščito pred napadi",
  "Stops animations and reduces color saturation.": "Ustavi animacije in zmanjša nasičenost barv.",
  "Blind Profile": "Profil za slepe uporabnike",
  "Activates the screen reader for auditory navigation.": "Omogoči bralnik zaslona za zvočno navigacijo.",
  "Visually Impaired Profile": "Profil za slabovidne uporabnike",
  "Enhances contrast and readability for low vision.": "Poveča kontrast in berljivost za slabovidne.",
  "ADHD Friendly Profile": "Profil prijazen za ADHD",
  "Reduces distractions for better focus.": "Zmanjša moteče dejavnike za boljšo osredotočenost.",
  "Cognitive & Learning Profile": "Profil za kognitivne sposobnosti in učenje",
  "Helpful tools for reading and comprehension.": "Uporabna orodja za branje in razumevanje.",
  "Motor Impaired Profile": "Profil za motorično ovirane uporabnike",
  "Optimizes the site for keyboard-only navigation.": "Optimizira stran za navigacijo samo s tipkovnico.",
  "Headings": "Naslovi",
  "Landmarks": "Značilni objekti",
  "Links": "Povezave",
  "Focus element": "Element fokusa",
  "Visit link": "Obišči povezavo"
}